import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-owner-medical-appointment-detail',
  templateUrl: './owner-medical-appointment-detail.component.html',
  styleUrls: ['./owner-medical-appointment-detail.component.css']
})
export class OwnerMedicalAppointmentDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
